import React, { useState } from 'react';
import { AllCourseList } from './AllCourseList';
import './course.css';
import { OngoingCourseList } from './OngoingCourseList';

export const CourseList = () => {
  const [searchKey, setSearchKey] = useState('');
  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchKey(value);
  };
  return (
    <div className='courselist'>
      <div className='container'>
        <div className='row'>
          <div className='d-flex justify-content-center'>
            <div className='search_baground'>
              <img src='img/Search.png' className='searchicon' />
              <input
                className='search_course'
                value={searchKey}
                onChange={handleSearch}
                type='text'
                name='searchKey'
                aria-label='Search'
                placeholder='Search for a course'
              />
            </div>
          </div>
        </div>
        <OngoingCourseList searchKey={searchKey} />
        <AllCourseList searchKey={searchKey} />
        <div className='courselistcontainer'>
          <img src='/img/Illustration.png' className='courselistimg' />
        </div>
      </div>
    </div>
  );
};
